import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Row, Col, Spinner, Form } from 'react-bootstrap';
import { InputField, SelectField } from "../../../lib/formControls";
import { uploadToS3 } from "../../../lib/appFileUpload";
import imageIcon from "../../../common/images/imageIcon.png";

const MAX_FILE_SIZE = 30 * 1024 * 1024; // 50MB
const MIN_FILE_SIZE = 1 * 1024;        // 1KB

const SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/svg+xml'
];

const schema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  staffId: yup.string().required('Staff ID is required'),
  gender: yup.string().required('Select the gender'),
  email: yup.string().email('Enter a valid email').required('Email is required'),
  phone: yup
    .string()
    .required('Phone number is required')
    .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits'),
  profileImageInpt: yup
      .mixed()
      .nullable()
      .test('fileType', 'Only image files are allowed', (value) => {
        if (!value) return true; // not mandatory
        return SUPPORTED_FILE_TYPES.includes(value.type);
      })
      .test('fileSize', 'File size must be between 1KB and 30MB', (value) => {
        if (!value) return true; // not mandatory
        return value.size >= MIN_FILE_SIZE && value.size <= MAX_FILE_SIZE;
      })   
});


const UserForm = ({ mode = 'add', onSubmit, initialData = {}, loading=false }) => {
  const {
  register,
  handleSubmit,
  reset,
  watch,
  setValue,
  clearErrors,
  control,
  formState: { errors, isSubmitting }
} = useForm({
  resolver: yupResolver(schema, { context: { mode } }),
  defaultValues: {
    firstName: '',
    lastName: '',
    staffId: '',
    gender: '',
    email: '',
    phone: '',
    profileImageInpt: '',
    profileImage: ''
  }
});

    const [file, setFile] = useState(null);
    const [fileUploading, setFileUploading] = useState(false);
    const [actiondisable, setActiondisable] = useState(true);

    const watchFirstName = watch("firstName");
    const watchLastName = watch("lastName");
    const watchStaffId = watch("staffId");
    const watchGender = watch("gender");
    const watchPhone = watch("phone");
    const watchProfileImage = watch("profileImage");
  
    useEffect(() => {
      if (watchFirstName || watchLastName || watchStaffId || watchPhone || watchProfileImage || watchGender) {
        setActiondisable(false);
      }
      if (watchFirstName === '' && watchLastName === '' && watchStaffId === '' && watchPhone === '' && watchProfileImage === '' && watchGender === '') {
        setActiondisable(true);
      }
    }, [watchFirstName, watchLastName, watchStaffId, watchPhone, watchProfileImage, watchGender]);

  // Prefill form in edit mode
  useEffect(() => {
    if (mode === 'edit' && initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }
  }, [mode, initialData, setValue]);

  /*const handleFormSubmit = (data) => {
    console.log('sagvdysaviy');
    onSubmit(data);
  };*/

  const handleSubmitForm = (data) => {
    console.log('Submitting form data:', data);
    onSubmit(data);
  };

  const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile(selectedFile);
          setValue('profileImageInpt', selectedFile);
          setValue('profileImage', '');
          setFileUploading(true); 
          clearErrors('profileImageInpt');
  
          try {
  
            const timestamp = Date.now();
            const fileExtension = selectedFile.name.split(".").pop() || "jpeg";
            const filename = `profile-${timestamp}.${fileExtension}`;
  
            const { key, url } = await uploadToS3({
              file: selectedFile,
              key: `gemicates/${filename}`,
              contentType: selectedFile.type,
            });
  
            console.log('url=', url);
            // Set the file URL to the form
            setValue('profileImage', url);
          } catch (err) {
            console.error("Error uploading file to S3:", err);
            clearErrors('profileImageInpt');
          } finally {
            setFileUploading(false);  
          }
        } else {
          setFile(null);
          setValue('profileImageInpt', '');
          setValue('profileImage', '');
        }
  };

  return (
    <form className='user-from-main' onSubmit={handleSubmit(handleSubmitForm)}>
        
        <Row>
         <Col md={12}>
          <InputField
            label="Employee First Name"
            name="firstName"
            type="text"
            placeholder="Employee First Name"
            controlclass="mb-3"
            register={register}
            required={true}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
        </Row>

        <Row>
        <Col md={12}>
          <InputField
            label="Employee Last Name"
            name="lastName"
            type="text"
            placeholder="Employee Last Name"
            controlclass="mb-3"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Staff ID"
            name="staffId"
            type="text"
            placeholder="Staff ID"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <SelectField
          label="Gender"
          name="gender"
          control={control}
          options={[
            { label: 'Select Gender', value: '' },
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Others', value: 'Others' }
          ]}
          placeholder=""
          required={true}
          errors={errors}
          className="custom-input-pd form-custom-group"            
        />
      </Col>
    </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Contact Number"
            name="phone"
            type="text"
            placeholder="Contact Number"
            controlclass="mb-3"
            register={register}
            required={true}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Email"
            name="email"
            type="email"
            placeholder="Email"
            controlclass="mb-3"
            register={register}
            required={true}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Form.Group controlId="profileImageInpt" className="mb-3 profile-imagegroup-maindiv">
            <Form.Label>Photo</Form.Label>

            <div className="custom-upload-wrapper">
              {fileUploading && (
                <div className="upload-overlay">
                  <Spinner animation="border" size="sm" />
                </div>
              )}

              <Form.Control
                type="file"
                name="profileImageInpt"
                onChange={handleFileChange}
                disabled={fileUploading}
                className={!!errors?.['profileImageInpt'] ? 'custom-file-input is-invalid' : 'custom-file-input'}
              />

              
              <div className="upload-placeholder">
                <i className="bx bx-upload"></i>
                <span>Upload</span>
              </div>
              
            </div>
            {file && (
                <div className="uploaded-file">
                  <img src={imageIcon} alt='icon' />
                  <div>
                    <div className="file-name">{file.name}</div>
                    <div className="file-size">
                      {(file.size / 1024).toFixed(0)} kb
                    </div>
                  </div>
                </div>
              )}
            <Form.Control.Feedback type="invalid">
              {errors?.['profileImageInpt']?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <div className="col-md-12 d-flex justify-content-between mt-auto mt-3 action-btn-buttomdiv">
        <Button variant="secondary custom-cnl-btncls" disabled={actiondisable || isSubmitting || loading} type="button" onClick={() => reset()}>
          Cancel
        </Button>
        <Button type="submit" disabled={actiondisable || isSubmitting || loading} variant="primary custom-sbm-btncls">
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              {' '}{mode === 'edit' ? 'Updating employee...' : 'Adding employee...'}
            </>
          ) : (
            mode === 'edit' ? 'Update Employee' : 'Add Employee'
          )}
        </Button>
      </div>
    </form>
  );
};

export default UserForm;
